module.exports = __webpack_public_path__ + "img/mv.dd23d996.svg";